/** When this tab last wrote its post-login redirect target; per tab, like ESA's sessionStorage copy of the target. */
const STAMP_KEY = 'tio-redirect-target-stamped-at';

/**
 * On storage failure the target reads as stale and is dropped.
 *
 * @param now epoch milliseconds
 */
export function stampRedirectTarget(now = Date.now()) {
  try {
    sessionStorage.setItem(STAMP_KEY, String(now));
  } catch {
    // Storage unavailable (private mode, blocked site data).
  }
}

/** Epoch milliseconds of the last stamp, or `null` when none is readable. */
export function redirectTargetStampedAt() {
  try {
    const stampedAt = Number(sessionStorage.getItem(STAMP_KEY));
    return Number.isFinite(stampedAt) && stampedAt > 0 ? stampedAt : null;
  } catch {
    return null;
  }
}

/** A storage failure is swallowed. */
export function clearRedirectTargetStamp() {
  try {
    sessionStorage.removeItem(STAMP_KEY);
  } catch {
    // Storage unavailable.
  }
}
